export const language: any = {
  main: "ပင်မ",
  ingredients: "ပါဝင်ပစ္စည်းများ",
  ai_chef: "AI chef",
  favorites: "အကြိုက်ဆုံးများ",
  menu: "မီနူး",
  get_start: "စတင်ပါ",
  title_first_1: "အသက်အလိုက် ဟင်းလျာများ အကြံပြုခြင်း",
  title_second_1: "မီနူးမှ ဟင်းလျာထိ အစီအစဉ် ပြည့်စုံသော စီမံချက်များ",
  content_1: "နေ့စဉ်မီနူးနဲ့ ကယ်လိုရီစဉ်းစားမှုတွေကို စိတ်ပူရတာ ရပ်လိုက်ပါ။ ယခုမှစ၍ Hey Cooker မှ အကြံပြုချက်များရယူပါ!",
  title_first_2: "ယနေ့ လေအေးတယ်၊ နေ့ကုန်ပင်ပန်းတယ်။",
  title_second_2: "အလုပ်ပြီးရင် အာမီဟင်းချိုလေး စားကြည့်ရအောင်လား?",
  content_2: "အိမ်ခန်းမှာကျန်တဲ့ အသားအိုးကန်၊ နှင့် ခေါက်ဆွဲခြောက်များကို ရှာပြီး ဟင်းလျာရိုးရိုးလေး ပြင်ကြည့်ပါ!",
  my_food_ingredients: "ဘာချက်ရမလဲဆိုတာ မသိပါဘူးလား?",
  btn_add_photo: "ရုပ်ပုံရွေးရန် သို့မဟုတ် ဓာတ်ပုံယူပါ",
  my_food_reason: "သင်မှာရှိတဲ့ ပါဝင်ပစ္စည်းတွေရွေးပါ",
  btn_get_cooking: "AI ဟင်းချက် အကြံပြုချက်ရယူပါ",
  enriching_title: "ခန္ဓာကိုယ်နှင့် စိတ်ကို တိုးတက်စေပါ",
  enriching: "ဟင်းလျာများ စုစည်းမှု",
  photo_registration_title: "ဓာတ်ပုံများ သို့မဟုတ် ဘောင်ချာများကို ရိုက်ကူးပြီး<br/>မီနူးအကြံပြုချက်ရယူပါ!",
  photo_registration_content: `AI အသုံးပြုပြီး ပစ္စည်းများကို ဖော်ထုတ်ကာ<br/>အခြားများနှင့်ဟက်ပျောမှုကို ပိုမိုကောင်းမွန်စေပါ!`,  
  food_suggestions_title: "ဘာစားရမလဲ စိတ်ပူနေလား?",
  food_suggestions_sub_title: "အဓိက ဟင်းလျာများ",
  our_interests_title: "သင်နှင့်မိသားစုအတွက် သင့်လျော်သောမီနူးကို ဖန်တီးပါ!",
  our_interests_sub_title: "အသက်အရွယ်နှင့် လိင်အလိုက် ရွေးချယ်ပါ။",
  favorite_title: "ဟင်းချက်စာအုပ် အမျိုးမျိုး",
  weather_title: "အေးချမ်းသောရာသီအတွက် သင့်လျော်သော ဟင်းလျာများ",
  video_title: "အသက်ဝင်သော ဗီဒီယိုများကို ကြည့်ပါ",
  tag: {
    close: "ပိတ်ရန်",
    open: "ချဲ့ရန်"
  },
  no_data: "အချက်အလက် မရှိပါ",
  update_version_submit: "အခုတင်သွင်းပါ",
  update_version_title: "အက်ပ်၏နောက်ဆုံးဗားရှင်းရှိပါသည်။",
  update_version_content: "အသုံးပြုမှုအတွေ့အကြုံအတွက် နောက်ဆုံးဗားရှင်းသို့ အပ်ဒိတ်လုပ်ပါ။",
  close_btn: "ပိတ်ရန်",
  not_video_id: "ဗီဒီယိုမရှိပါ",
  favorite_login: "သင်၏အနှစ်သက်ဆုံးချက်ပြုတ်နည်းစာရင်းကို သိမ်းရန် ဝင်ရောက်ပါ သို့မဟုတ် စာရင်းသွင်းပါ။",
  favorite_section_title: "သင့်မှတ်သားထားသောချက်ပြုတ်နည်းများကို မမေ့ပါနှင့်",
  favorite_section_description: "ကျွန်ုပ်နှစ်သက်သောချက်ပြုတ်နည်းများ",
  discover: "ရှာဖွေပါ",
  my_cooker: "ကျွန်ုပ်၏မီးဖိုချောင်",
  view_recipe: "ရွေးချယ်ထားသောပါဝင်ပစ္စည်းများမှချက်ပြုတ်နည်းများကြည့်ရှုပါ",
  my_ingredient: "ကျွန်ုပ်၏ပါဝင်ပစ္စည်းများ",
  add_ingredient: "ကျွန်ုပ်၏ပါဝင်ပစ္စည်းများထည့်ပါ",
  video_section_title: "ဗီဒီယိုများမှ ရှာဖွေနှင့် ခံစားပါ",
  video_section_description: "အကြံပြုချက် အစားအစာဗီဒီယို",
  age_10: "အသက် ၁၀ နှစ်အောက်",
  age_10_to_20: "၁၀-၂၀ နှစ်",
  age_20_to_30: "၂၀-၃၀ နှစ်",
  age_30_to_40: "၃၀-၄၀ နှစ်",
  age_40_to_50: "၄၀-၅၀ နှစ်",
  age_more_50: "၅၀ နှစ်အထက်",
  suggest_section_title: "ဟေး! Cooker သင့်ရဲ့ ရွေးချယ်မှုကို အကူအညီပေးပါမယ်",
  suggest_section_description: "သင်စိတ်ဝင်စားသော ခေါင်းစဉ်များက ဘာလဲ?",
  weather_title1: "ယနေ့အတွက် အကြံပြုချက်များ",
  weather_title2: "မိုးရွာပြီးအေးမြသောနေ့တွင် ဘာစားရမလဲ?",
  tasteSuggestion1: "သင့်အာရုံခံကို ကျေနပ်စေပါ",
  tasteSuggestion2: "သင့်အတွက်သာဖြစ်သော အရသာများ",
  tasteTitle1: "စပ်သော နှင့်<br /> ဆွဲဆောင်မှုရှိသော",
  tasteDescription1: "#ကြော် #အူ #မိုးနေ့",
  tasteTitle2: "လတ်ဆတ်ပြီး <br />ပေါ့ပါးသော",
  tasteTitle3: "ချဉ်ပြီး <br />စိတ်လှုပ်ရှားဖွယ်",
  tasteTitle4: "မွှေးပျံ့သော - <br />ချိုသော",
  tasteTitle5: "ရောနှောပြီး <br />ဆွဲဆောင်မှုရှိသော",
  tasteDescription2: "#လတ်ဆတ် #ဖိုက်ဘာ #အာဟာရလျှော့ချ",
  tasteDescription3: "#ချဉ် #ချို #စိတ်လှုပ်ရှားဖွယ်",
  tasteDescription4: "#ထူးခြားသော #စေ့များ #အံ့ဖွယ်",
  tasteDescription5: "#အရသာ #အာဟာရ #ခံစားမှု",
  suggest_item_title1: "လွယ်ကူသော ချက်ပြုတ်ချက်များ",
  suggest_item_description1: `လွယ်ကူသော မနက်စာနှင့် နေ့လည်စာ<br/>ချက်ပြုတ်နည်းများ`,
  suggest_item_title2: "အဝလျော့အစားအစာ",
  suggest_item_description2: `နိမ့်မန်နိုဟိုက်ဒရိတ်<br/>အရသာရှိတဲ့ ဟင်းလျာများ`,
  suggest_item_title3: "နှစ်ကုန်စာအစားအစာ",
  suggest_item_description3: `အိမ်ပြင်ဖျော်ဖြေရေး အစားအစာ`,
  suggest_item_title4: "ကျန်းမာရေးအစားအစာ",
  suggest_item_description4: `ကျန်းမာသော ကိုယ်နှင့် စိတ်ကို<br/>တည်ဆောက်ရန်`,
  suggest_item_title5: "လွယ်ကူသော နွားခြောက်",
  suggest_item_description5: `အိမ်အတွင်း အပျော်စရာ အစရှိသော အစားအစာ`,
  history: "ပုံသတင်းအချက်အလက်ခွဲခြမ်းစိတ်ဖြာမှတ်တမ်း",
  community: {
    sub_title: "တိုင်းသူတိုင်းသားနှင့်အတူချက်ပြုတ်ပါ",
    title: "ဟယ်! မီးဖိုချောင်အသိုင်းအဝိုင်းရှာဖွေရန်",
    trending: "လူကြိုက်များ",
    follow: "နောက်ကိုလိုက်သည်",
    video: "ဗီဒီယို",
    discover: "ရှာဖွေ",
    no_data: "Hey! Cooker မီးဖိုချောင်မှ အသစ်များမရှိပါ",
    discover_post: "အသိုင်းအဝိုင်းထဲတွင် ပိုမိုသောပို့စ်များကို ရှာဖွေနေပါသည်"
  },
  user_suggest_title1: "ယနေ့အတွက် အကြံပြုချက်များ",
  user_suggest_title2: "ချက်ပြုတ်နည်း မဖြစ်မနေ အကြံပြုချက်",
}



